import { FormData } from 'contexts/reward-context'
import { useRewardContext } from 'contexts/useRewardContext'
import { Field, FieldArray, FormikProvider, useFormik } from 'formik'
import { Formatter } from 'utils/formatters'

import { Employee, FormValues, ModalEmployeesProps } from './type'

export function ModalEmployees({
  setModalEmployees,
  dataModal,
  handleClick,
}: Readonly<ModalEmployeesProps>) {
  const { steps, setSteps } = useRewardContext()

  const formikNewEmployees = useFormik<FormValues>({
    initialValues: {
      employees: dataModal.map((item: Employee) => ({
        email: item.email,
        name: '',
      })),
    },
    onSubmit: async (values) => {
      const employeesWithCapitalizedNames = values.employees.map(
        (employee: Employee) => ({
          ...employee,
          name: employee.name ? Formatter.capitalizeWords(employee.name) : '',
        }),
      )
      const newDatas = employeesWithCapitalizedNames.filter(
        (employee: Employee) => employee.name,
      )

      const updateStep: FormData[] = steps.map((step) => {
        const newData = newDatas.find(
          (employee: Employee) => employee.email === step.email,
        )
        return newData ? { ...step, ...newData } : step
      })

      setSteps(updateStep)
      handleClick(1)
    },
  })

  return (
    <section className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 shadow-2xl">
      <div className="bg-white flex items-center flex-col m-4 md:m-auto w-[45rem] relative dark:bg-neutral-800 p-4 rounded-2xl shadow-lg">
        <div>
          <h1 className="text-[17px] font-medium">
            Alguns e-mails informados não estão na sua base de Colaboradores,
            por favor, indique o nome deles para que o cadastro seja feito.
          </h1>
        </div>
        <FormikProvider value={formikNewEmployees}>
          <form
            className="w-[20rem] mt-4"
            onSubmit={formikNewEmployees.handleSubmit}
          >
            <FieldArray name="employees">
              {() => (
                <>
                  <section className="w-full h-full flex flex-col justify-start items-start">
                    {formikNewEmployees.values.employees.map(
                      (employee: Employee, index: number) => (
                        <div
                          key={index}
                          className="mb-4 ml-[-21] w-full relative"
                        >
                          <label
                            htmlFor={`employees.${index}.name`}
                            className="block text-sm font-medium text-neutral-900 dark:text-neutral-300 mt-4 whitespace-nowrap"
                          >
                            {`Primeiro Nome - ${employee.email}`}
                          </label>
                          <Field name={`employees.${index}.name`}>
                            {({ field, form }: any) => (
                              <input
                                {...field}
                                type="text"
                                className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                onChange={(e) => {
                                  const capitalizedValue =
                                    Formatter.capitalizeWords(e.target.value)
                                  form.setFieldValue(
                                    `employees.${index}.name`,
                                    capitalizedValue,
                                  )
                                }}
                              />
                            )}
                          </Field>
                        </div>
                      ),
                    )}
                  </section>
                  <div className="w-full flex mt-4 gap-2 justify-between items-center">
                    <button
                      type="button"
                      className={`
                  bg-neutral-200 hover:bg-neutral-400/60 dark:bg-neutral-700
                  hover:dark:bg-neutral-700/60 transition-colors duration-500
                  ease-in-out text-neutral-900 dark:text-neutral-200 px-6
                  py-2 rounded-full disabled:cursor-not-allowed disabled:bg-neutral-200
                  disabled:hover:bg-neutral-200 dark:disabled:bg-neutral-700
                  dark:disabled:hover:bg-neutral-700 text-sm md:text-base w-1/3
                `}
                      onClick={() => {
                        setModalEmployees(false)
                      }}
                    >
                      Voltar
                    </button>
                    <button
                      type="submit"
                      className={`
                  bg-[#4F46E5] text-white rounded-full px-5 py-3 hover:opacity-95
                ${
                  !formikNewEmployees.dirty || !formikNewEmployees.isValid
                    ? 'cursor-not-allowed bg-[#4F46E5]/80'
                    : ''
                }

                `}
                      disabled={
                        !formikNewEmployees.dirty || !formikNewEmployees.isValid
                      }
                    >
                      Continuar
                    </button>
                  </div>
                </>
              )}
            </FieldArray>
          </form>
        </FormikProvider>
      </div>
    </section>
  )
}
